import { createBrowserRouter, Navigate } from 'react-router-dom'
import type { RouteObject as ReactRouterRouteObject } from 'react-router-dom'
import type { RouteObject } from './interface'
import RootLayout from '../Layout/RootLayout'
import RouteErrorPage from '@/components/RouteErrorPage'
import BacktestPage from '@/pages/BacktestPage'
import ManagersPage from '@/pages/ManagersPage'
import OperateManagerPage from '@/pages/ManagersPage/OperateManagerPage'
import ManagerDetailPage from '@/pages/ManagersPage/ManagerDetailPage'
import BacktestsPage from '@/pages/BacktestsPage'
import BacktestDetailPage from '@/pages/BacktestsPage/components/Detail'
import CompareBacktestPage from '@/pages/BacktestsPage/components/CompareBacktest'
import PoolPage from '@/pages/PoolPage'
import StrategyVersionPage from '@/pages/ManagersPage/StrategyVersion'
import AssetManagementPage from '@/pages/AssetManagement'
import CreateAssetPortfolioPage from '@/pages/AssetManagement/create'
import AssetDetailPage from '@/pages/AssetManagement/detail'
import StockKBPage from '@/pages/StockKB'
import StockKBDetailPage from '@/pages/StockKB/detail'
import StockReportDetailPage from '@/pages/StockKB/detail/report'
import QuarterlyReportDetailPage from '@/pages/StockKB/detail/quarterly-report'
import StockNewKBDetailPage from '@/pages/StockNewKB/detail'
import ReviewPage from '@/pages/ReviewPage'
import LoginPage from '@/pages/LoginPage'
import OrganizationPage from '@/pages/OrganizationPage'
import AcceptInvitationPage from '@/pages/AcceptInvitationPage'
import ProtectedLayout from '@/auth/ProtectedLayout'

export const routes : RouteObject[]= [
    { index: true, element: <Navigate to="/managers" replace /> },
    { path: 'backtests', element: <BacktestsPage /> ,handle:{title:'投资策略回测'}},
    { path: 'managers', element: <ManagersPage /> ,handle:{title:'智能组合经理'}},
    { path: 'managers/operate', element: <OperateManagerPage /> ,handle:{title:'新建资金经理',key:'managers',parent:'智能组合经理'}},
    { path: 'managers/operate/:id', element: <OperateManagerPage /> ,handle:{title:'编辑资金经理',key:'managers',parent:'智能组合经理'}},
    { path: 'managers/:id', element: <ManagerDetailPage /> ,handle:{title:'基金经理详情',parent:'智能组合经理',key:'managers'}},
    { path: 'backtests/backtest', element: <BacktestPage /> ,handle:{title:'新建回测',key:'backtests',parent:'投资策略回测'}},
    { path: 'backtests/backtest/:run_id', element: <BacktestDetailPage /> ,handle:{title:'回测详情',key:'backtests',parent:'投资策略回测'}},
    { path: 'backtests/compare/:ids', element: <CompareBacktestPage /> ,handle:{title:'多回测对比',key:'backtests',parent:'投资策略回测'}},
    { path: 'pool', element: <PoolPage /> ,handle:{title:'股票池'} },
    { path: 'versionManage', element: <StrategyVersionPage /> ,handle:{title:'策略版本管理',key:'managers',parent:'智能组合经理'} },
    { path: 'asset-mgmt', element: <AssetManagementPage />, handle: { title: '资产管理' } },
    { path: 'asset-mgmt/create', element: <CreateAssetPortfolioPage />, handle: { title: '新建组合', key: 'asset-mgmt', parent: '资产管理' } },
    { path: 'asset-mgmt/:id', element: <AssetDetailPage />, handle: { title: '组合详情', key: 'asset-mgmt', parent: '资产管理' } },
    { path: 'stock-kb', element: <StockKBPage />, handle: { title: '个股知识库' } },
    { path: 'stock-kb/:code', element: <StockKBDetailPage />, handle: { title: '个股详情', key: 'stock-kb', parent: '个股知识库' } },
    { path: 'stock-kb/:code/report/:reportId', element: <StockReportDetailPage />, handle: { title: '财报详情', key: 'stock-kb', parent: '个股知识库' } },
    { path: 'stock-kb/:code/quarterly-report/:reportId', element: <QuarterlyReportDetailPage />, handle: { title: '季报详情', key: 'stock-kb', parent: '个股知识库' } },
    { path: 'stock-new-kb/:code', element: <StockNewKBDetailPage />, handle: { title: '新知识库详情', key: 'stock-new-kb', parent: '股票池' } },
    { path: 'review', element: <ReviewPage />, handle: { title: '投资审核' } },
    { path: 'organization', element: <OrganizationPage />, handle: { title: '企业与成员' } },
]


  const router = createBrowserRouter([
    {
        path: '/login',
        element: <LoginPage />,
    },
    {
        element: <ProtectedLayout />,
        errorElement: <RouteErrorPage />,
        children: [
            {
                path: '/accept-invitation',
                element: <AcceptInvitationPage />,
            },
            {
                path: '/',
                element: <RootLayout />,
                children: [
                    {
                        errorElement: <RouteErrorPage />,
                        children: routes as ReactRouterRouteObject[],
                    },
                ],
            },
        ],
    },
])

export default router
